
/**
 * @export
 * @type BulkActionLog
 */
export type BulkActionLog = {
    operationId: string;
    startTime: string;
    jobName: string;
    jobType: BulkActionLogJobType;
    jobStatus: BulkActionLogJobStatus;
}

export enum BulkActionLogJobType {
    IMPORT_USER = 'IMPORT_USER',
    WELCOME_EMAIL = 'WELCOME_EMAIL',
    DEPRECATED_JOB = 'DEPRECATED_JOB',
    ATTENDEE_IMPORT = 'ATTENDEE_IMPORT',
    UPDATE_USER_CRM = 'UPDATE_USER_CRM',
    UPDATE_USER_GROUP = 'UPDATE_USER_GROUP',
    UPDATE_USER_STATE = 'UPDATE_USER_STATE',
    UPDATE_ADMIN_ROLE = 'UPDATE_ADMIN_ROLE',
    UPDATE_AM_RELATION = 'UPDATE_AM_RELATION',
    UPDATE_USER_STATUS = 'UPDATE_USER_STATUS',
    REMOVE_AM_RELATION = 'REMOVE_AM_RELATION',
    DEVICE_REGISTRATION = 'DEVICE_REGISTRATION',
    UPDATE_USER_ACCOUNT = 'UPDATE_USER_ACCOUNT',
    ENABLE_ACCESS_MODULE = 'ENABLE_ACCESS_MODULE',
    UPDATE_ACCOUNT_STATUS = 'UPDATE_ACCOUNT_STATUS',
    DISABLE_ACCESS_MODULE = 'DISABLE_ACCESS_MODULE',
    UPDATE_USER_NEWSLETTER = 'UPDATE_USER_NEWSLETTER',
    CONFERENCE_USERS_REMOVE = 'CONFERENCE_USERS_REMOVE',
    UPDATE_USER_MFA = 'UPDATE_USER_MFA',
    ENABLE_LCD_SUBSCRIPTION = 'ENABLE_LCD_SUBSCRIPTION',
    DISABLE_LCD_SUBSCRIPTION = 'DISABLE_LCD_SUBSCRIPTION',
    ASSIGN_ACCOUNT_ENTITLEMENTS = 'ASSIGN_ACCOUNT_ENTITLEMENTS',
    DISCHARGE_ACCOUNT_ENTITLEMENTS = 'DISCHARGE_ACCOUNT_ENTITLEMENTS',
    ASSIGN_USER_ENTITLEMENTS = 'ASSIGN_USER_ENTITLEMENTS',
    DISCHARGE_USER_ENTITLEMENTS = 'DISCHARGE_USER_ENTITLEMENTS',
    ASSIGN_PRODUCT_SEAT = 'ASSIGN_PRODUCT_SEAT',
    UNASSIGN_PRODUCT_SEAT = 'UNASSIGN_PRODUCT_SEAT'
}

export enum BulkActionLogJobStatus {
    STOPPED = 'STOPPED',
    FAILED = 'FAILED',
    COMPLETED = 'COMPLETED',
    EXECUTING = 'EXECUTING',
    UNKNOWN = 'UNKNOWN'
}